import { BaseService } from "./Base/BaseService";
import * as crypto from "crypto-js";
import { makeAutoObservable } from "mobx";

class GlobalData {
  CurrentUser: ICurrentUser | null = null;

  constructor() {
    makeAutoObservable(this);
    this.loadFromLocalStorage();
  }

  saveToLocalStorage() {
    const data = {
      CurrentUser: this.CurrentUser,
    };
    const encryped = crypto.AES.encrypt(JSON.stringify(data), BaseService.SecretCryptoCode).toString();
    localStorage.setItem(BaseService.UserLocalStorageKey, encryped);
  }

  updateLocalStorage() {
    this.removeUserFromLocalStorage();
    this.saveToLocalStorage();
  }

  removeUserFromLocalStorage() {
    localStorage.removeItem(BaseService.UserLocalStorageKey);
  }

  removeTokenFromLocalStorage() {
    localStorage.removeItem(BaseService.TokenLocalStorageKey);
  }

  loadFromLocalStorage() {
    const token = localStorage.getItem(BaseService.UserLocalStorageKey);
    if (!token) return;

    const bytes = crypto.AES.decrypt(token, BaseService.SecretCryptoCode);
    const data = JSON.parse(bytes.toString(crypto.enc.Utf8));

    if (!data) return;
    this.CurrentUser = data.CurrentUser;
  }
}

export interface ICurrentUser {
  id: number;
  email: string;
  role: UserRole;
  access_token: string;
  isMaster: boolean;
  name: string;
  avatar_url: string;
}

export type UserRole = "client" | "master" | "admin";

export class CurrentUser {
  Id: number;
  Email: string;
  Role: UserRole;
  IsMaster: boolean;
  Name: string;
  AvatarUrl: string;

  constructor(dto: ICurrentUser) {
    this.Id = dto.id;
    this.Email = dto.email;
    this.Role = dto.role;
    this.IsMaster = dto.isMaster;
    this.AvatarUrl = dto.avatar_url;
    this.Name = dto.name;
  }
}

export const globalData = new GlobalData();
